import styled from "styled-components";

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CarouselContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  overflow: hidden;
`;

export const CarouselImages = styled.div`
  display: flex;
  transition: transform 0.5s ease;
  transform: ${({ startIndex, numberOfImagesPerSlide }) =>
    `translateX(-${startIndex * (100 / numberOfImagesPerSlide)}%)`};
  gap: 14px;
`;

export const CarouselImage = styled.img`
  flex: 1 0
    calc(
      (100% / ${({ numberOfImagesPerSlide }) => numberOfImagesPerSlide}) - 14px
    );
  max-width: calc(
    (100% / ${({ numberOfImagesPerSlide }) => numberOfImagesPerSlide}) - 14px
  );
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  object-fit: cover;
  object-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
  aspect-ratio: 1/1;
  cursor: ${({ showPointer = false }) => (showPointer ? "pointer" : "default")};
`;

export const CarouselButton = styled.button`
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  &.left {
    left: 10px;
  }

  &.right {
    right: 10px;
  }
`;

export const SliderActionsContainer = styled.div`
  display: grid;
  place-content: center;
`;

export const SliderArrowsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SliderArrowContainer = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const SliderProgressBarContainer = styled.div`
  width: 150px;
  height: 1px;
  position: relative;
  background-color: ${({ theme }) => theme.border.black10};
`;

export const SliderProgressBar = styled.div`
  background-color: ${({ theme }) => theme.bg.black};
  height: 2px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: ${({ width }) => `${width}%`};
`;

export const SliderHeading = styled.h1`
  margin: 0;
  text-align: ${({ textAlign }) => textAlign};
  font-size: 20px;
  font-weight: 400;
`;
